import {React} from "react";

import './Footer.scss'
import JButton from '../../components/Button/JButton'

const  Footer= () => {
    return ( 
        <div>
            <div className="footer1">
                <div className="licence">
                    <div className="logoSiteParent">
                        <div className="logoSiteFooter"></div>
                    </div>
                    <span>گروه شرکت های انتقال داده ماهان</span>
                    <label>انتقال داده ماهان دارنده پروانه ارتباطات ثابت به شماره  ۱۷-۹۵-۱۰۰  از سازمان تنظیم مقررات و ارتباطات رادیویی</label>
                </div>
                <div className="mobileApp">
                    <div  className="calling">
                        <div>
                            <JButton  title={""} href={"tel:1514"} leftIcon={"fa fa-volume-control-phone"} type={"LTE"} noSize={true} />
                        </div>
                        <span>
                            <a href="tel:1514" target="_blank">۱۵۱۴</a>
                        </span>
                        <i className="countryNumber">(شماره کشوری)</i>
                    </div>
                    {/* <div className="application">
                        <div>
                            <JButton  title={""} href={"http://mahannet.ir/application/"} leftIcon={"fa fa-cloud-download"} type={"ADSL"} noSize={true} />
                        </div>
                        <span>دانلود اپلیکیشن ماهان نت</span>
                    </div> */}
                    <div className="application">
                        <div>
                            <JButton  title={""} href={"http://mahannet.ir"} leftIcon={"fa fa-globe"} type={"ADSL"} noSize={true} />
                        </div>
                        <span>سایت ماهان نت</span>
                    </div>
                </div>   
                <div className="enamad">
                    {/* <div> */}
                    <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=32313&amp;Code=fBD83AtEbff45s0ElONT"><img referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=32313&amp;Code=fBD83AtEbff45s0ElONT" alt="" styles="cursor:pointer" id="fBD83AtEbff45s0ElONT"/></a>
                    {/* </div> */}
                </div>
                <div className="socials">
                    {/* <a href="https://twitter.com" target="_blank"><div className="twitter"></div></a>
                    <a href="https://linkedin.com" target="_blank"><div className="linkedin"></div></a>
                    <a href="https://telegram.web" target="_blank"><div className="telegram"></div></a>
                    <a href="https://instagram.com" target="_blank"><div className="instagram"></div></a> */}
                    
                    <div>
                        <JButton  title={""} href={"https://t.me/mahannet_net"} leftIcon={"fa fa-telegram"} type={"Telegram"} noSize={true} />
                    </div>
                    <div>
                        <JButton  title={""} href={"https://www.aparat.com/mahannet.ir"} leftIcon={"fa fa-linkedin"} iconImage={true} type={"Aparat"} noSize={true} />
                    </div>
                    <div>
                        <JButton  title={""} href={"https://twitter.com/MahanNet_net"} leftIcon={"fa fa-twitter"} type={"Twitter"} noSize={true} />
                    </div>
                    <div>
                        <JButton  title={""} href={"https://www.instagram.com/mahannet.ir/"} leftIcon={"fa fa-instagram"} type={"Instagram"} noSize={true} />
                    </div>
                    <div>
                        <JButton  title={""} href={"https://www.linkedin.com/company/mahanet"} leftIcon={"fa fa-linkedin"} type={"Linkedin"} noSize={true} />
                    </div>
                </div>
            </div>
            <div className="footer2">
                <div className="copyRight">
                    اینترنت پر سرعت ماهان نت، کلیه حقوق این وب سایت متعلق به ماهان نت است.
                </div>
                <div className="site195">
                    <a href="http://195.ir" target="_blank">
                        <i>۱۹۵</i>
                        <span>سامانه پاسخگویی وزارت ارتباطات و فناوری اطلاعات</span>
                    </a>
                </div>
            </div>
        </div>
     );
}

export default Footer;
